<script lang="ts">
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';

	const { t } = getTranslate();

	export let tolgeePrefix = '__global';
	export let additionalClass = '';
</script>

<section class={classes('flex flex-col justify-center items-center py-16', additionalClass)}>
	<h2 class="text-4xl font-bold mb-4 text-center">
		{@html $t(`${tolgeePrefix}.headingSubline-section.title`)}
	</h2>
	<h4 class="text-lg font-normal text-center">
		{@html $t(`${tolgeePrefix}.headingSubline-section.subtitle`)}
	</h4>

	<slot />
</section>
